// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-tab-howto {
  display: block;
  margin: var(--wm-feature-details-margin);
}
wm-tab-howto .webmapp-title {
  font-weight: var(--wm-feature-details-title-font-weight);
  font-size: var(--wm-feature-details-title-font-size);
  color: var(--wm-feature-details-title-color);
  font-family: var(--wm-feature-details-title-font-family);
}
wm-tab-howto .webmapp-walkability {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  padding: 10px;
}
wm-tab-howto .webmapp-walkability .webmapp-walkability-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  margin: 0 10px 10px 0;
  padding: 10px;
  height: 82px;
  min-width: 80px;
  left: 0px;
  top: 932px;
  border-radius: 15px;
  background: rgba(255, 129, 40, 0.2);
}
wm-tab-howto .webmapp-walkability .webmapp-walkability-box i {
  position: static;
  height: 24px;
  width: 27.3333358765px;
  left: 11px;
  top: 947px;
  border-radius: 0px;
  font-size: 24px;
  color: #ff8128;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 8px 0px;
}
wm-tab-howto .webmapp-walkability .webmapp-walkability-box wm-icon > div svg {
  height: unset;
}
wm-tab-howto .webmapp-walkability .webmapp-walkability-box wm-icon > div svg circle {
  fill: transparent;
}
wm-tab-howto .webmapp-walkability .webmapp-walkability-box wm-icon > div svg g {
  fill: #ff8128;
}
wm-tab-howto .webmapp-walkability .webmapp-walkability-box .webmapp-walkability-label {
  font-family: var(--wm-font-family-header);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
wm-tab-howto .webmapp-walkability .webmapp-walkability-box:not(:has(wm-icon)) {
  justify-content: center;
  align-items: center;
}
wm-tab-howto .webmapp-walkability .webmapp-walkability-box:not(:has(wm-icon)) .webmapp-walkability-label {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/tab-howto/tab-howto.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wCAAA;AACF;AAAE;EACE,wDAAA;EACA,oDAAA;EACA,4CAAA;EACA,wDAAA;AAEJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;AAEJ;AAAI;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EAEA,YAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,mCAAA;AACN;AAAM;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EAEA,uBAAA;EAEA,UAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AAAR;AAIU;EACE,aAAA;AAFZ;AAIY;EACE,iBAAA;AAFd;AAIY;EACE,aAAA;AAFd;AAOM;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AALR;AASI;EACE,uBAAA;EACA,mBAAA;AAPN;AASM;EACE,kBAAA;AAPR","sourcesContent":["wm-tab-howto {\n  display: block;\n  margin: var(--wm-feature-details-margin);\n  .webmapp-title {\n    font-weight: var(--wm-feature-details-title-font-weight);\n    font-size: var(--wm-feature-details-title-font-size);\n    color: var(--wm-feature-details-title-color);\n    font-family: var(--wm-feature-details-title-font-family);\n  }\n  .webmapp-walkability {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-content: flex-start;\n    align-items: flex-start;\n    padding: 10px;\n\n    .webmapp-walkability-box {\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n      align-items: flex-start;\n      margin: 0 10px 10px 0;\n      padding: 10px;\n\n      height: 82px;\n      min-width: 80px;\n      left: 0px;\n      top: 932px;\n      border-radius: 15px;\n      background: rgba(255, 129, 40, 0.2);\n      i {\n        position: static;\n        height: 24px;\n        width: 27.333335876464844px;\n        left: 11px;\n        top: 947px;\n        border-radius: 0px;\n        font-size: 24px;\n        color: #ff8128;\n\n        /* Inside auto layout */\n\n        flex: none;\n        order: 0;\n        flex-grow: 0;\n        margin: 8px 0px;\n      }\n      wm-icon {\n        > div {\n          svg {\n            height: unset;\n\n            circle {\n              fill: transparent;\n            }\n            g {\n              fill: #ff8128;\n            }\n          }\n        }\n      }\n      .webmapp-walkability-label {\n        font-family: var(--wm-font-family-header);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 17px;\n        letter-spacing: 0em;\n        text-align: left;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-line-clamp: 3;\n        -webkit-box-orient: vertical;\n      }\n    }\n\n    .webmapp-walkability-box:not(:has(wm-icon)) {\n      justify-content: center;\n      align-items: center;\n\n      .webmapp-walkability-label {\n        text-align: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
